import { memo, useEffect, useState } from "react";
import { 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Box,
  CircularProgress,
  Stack,
  Switch,
  Skeleton,
  Grid,
  Typography,
  DialogContentText,
  Paper,
} from "@mui/material";
import NewItemFab from "../../../../components/new-item-fab";
import { useClassroomStore } from "../../../../store/classroom-store";
import PreviewCard from "../../../../components/preview-card";
import { useNavigate, useParams } from "react-router-dom";
import { Collection, CollectionStatus, createNewCollection } from "../../../../models/collection";
import LoadingSkeleton from "../../components/loading-skeleton";
import BackdropLoader from "../../../../components/backdrop-loader";
import CollectionCard from "../components/collection-preview-card";
import NewCollectionDialog from "../components/new-collection-dialog";
import DeleteCollectionDialog from "../components/delete-collection-dialog";
import { useClassroomActions } from "../../../../hooks/useClassroomActions";
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { useSnackbar } from "../../../../components/snackbar";
import { useDomainActions } from "../../../../hooks/useDomainActions";

interface CollectionsProps {
  hubActive: boolean | null;
}

function Collections({ hubActive }: CollectionsProps) {
  const { classroom_id } = useParams<{ classroom_id: string }>();

  const { classrooms, getCollections, updateCollection,
    deleteCollection
   } = useClassroomActions();
  
  const classroom = classrooms?.[Number(classroom_id)];

  const collections = classroom?.collections;
  

  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [runningTask, setRunningTask] = useState(-1);

  const [open, setOpen] = useState(false);

  const { showMessage } = useSnackbar();

  const preCreate = () => {
    if (!hubActive) {
      showMessage('Hub is not activated', 1);
      return;
    }

    if (runningTask !== -1) {
      showMessage('please wait', 1);
      return;
    };

    setOpen(true);
  }


  // const _updateCollection = async (col: Collection) => {
  //   await updateCollection(Number(classroom_id), col);
  //   onClose();
  // };

  
  const _deleteCollection = async (collection_id: number) => {
    setDeleting(true);
    await deleteCollection(Number(classroom_id), collection_id);
    setDeleting(false);
  };

  useEffect(() => {
    const loadCollections = async () => {
      await getCollections(Number(classroom_id))
    };
    setLoading(true);
    if (classroom && !collections) loadCollections();
    setLoading(false);
  }, [classrooms]);


  if (hubActive === null || loading || !collections) {
    return (
      <LoadingSkeleton/>
    );
  }

  const collectionsList = Object.values(collections);

  
  return (
    <Box>
      {collectionsList.length > 0 ? (
        <Grid container spacing={2}>
          {Object.values(collections)
            .sort((a, b) => new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime())
            .map((collection) => (
              <Grid key={collection.id} size={{ xs: 12, md: 6, lg: 4 }}>
                <CollectionCard
                  collection={collection}
                  // updateCollection={_updateCollection}
                  onDelete={_deleteCollection}
                  runningTask={runningTask}
                />
              </Grid>
          ))}
        </Grid>
      ) : (
        <Box>
          <Paper
            elevation={0}
            sx={{
                minHeight: 200,
                backgroundColor: "#f9fafb",
                border: "1px dashed #d1d5db",
                borderRadius: 2,
                px: 4,
                py: 6,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
            }}
          >
            <AddCircleOutlineOutlined sx={{ fontSize: 48, color: "#9ca3af", mb: 2 }} />

            <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>
                No Collections Yet
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 300 }}>
                You haven’t created any library collection for this classroom yet.
            </Typography>
          </Paper>
        </Box>
      )}
     

      <NewItemFab onClick={preCreate} />

      <NewCollectionDialog
        open={open}
        setOpen={setOpen}
        classroom_id={classroom_id!}
        setRunningTask={setRunningTask}
      />
      
      {deleting && <BackdropLoader/>}
    </Box>
  );
}

export default (Collections);